import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import { useLocation } from '@reach/router'
import Layout from '../components/layout'
import WpBlog from '../components/WpBlog'
import { flattenTags } from '../utils'
import '../components/wp.css'

const PostTemplate = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const navBarData = data.contentfulNavigationBar
  const footerData = data.contentfulFooterV2
  const blogData = data.wpPost
  const authorData = data.wpPost.author.node
  const relatedData = flattenTags(data.allWpPost.edges)
  const tags = data.wpPost.tags.nodes.map((tag) => tag)
  const defaultdata = data.wp.generalSettings
  const siteLanguages = data.site.siteMetadata.languages
  const latestBlogPost = data.latestPost.edges[0].node
  const location = useLocation()
  return (
    <Layout
      latestBlogPost={latestBlogPost}
      navBarData={navBarData}
      footerData={footerData}
      siteLanguages={siteLanguages}
      location={location}
    >
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        <WpBlog
          data={blogData}
          relatedData={relatedData}
          defaultdata={defaultdata}
          location={location}
          tags={tags}
          authorData={authorData}
        />
      </div>
    </Layout>
  )
}

export default PostTemplate

export const pageQuery = graphql`
  fragment node on WpPost {
    id
    isSticky
    title
    locale {
      locale
    }
    date(formatString: "MMMM D, YYYY")
    content
    status
    slug
    excerpt
    featuredImage {
      node {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 864
              height: 439
              placeholder: BLURRED
              formats: [WEBP, PNG]
            )
          }
          previewCardImage: childImageSharp {
            gatsbyImageData(width: 428, height: 217, placeholder: BLURRED)
          }
          publicURL
        }
        altText
      }
    }
    tags {
      nodes {
        name
        id
        slug
        locale {
          locale
        }
      }
    }
    author {
      node {
        firstName
        lastName
        description
        name
        slug
        extraCapabilities
        userProfile {
          authorProfile {
            ... on WpAuthor {
              slug
              ...authorNode
            }
          }
        }
      }
    }
    postOptions {
      featuredOverlayAlignment
      metaDescription
      metaTitle
    }
  }

  fragment GeneralSettings on Wp {
    generalSettings {
      authorBannerDefault {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 864
              height: 438
              transformOptions: { cropFocus: CENTER }
              layout: CONSTRAINED
            )
          }
          previewCardImage: childImageSharp {
            gatsbyImageData(width: 428, height: 217, placeholder: BLURRED)
          }
          featured: childImageSharp {
            gatsbyImageData(width: 864, height: 438, placeholder: BLURRED)
          }
          publicURL
        }
        altText
      }
      authorProfileDefault {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 168
              height: 168
              transformOptions: { cropFocus: CENTER }
              layout: CONSTRAINED
            )
          }
          publicURL
        }
        altText
      }
    }
  }

  query ($id: String!) {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    latestPost: allWpPost(
      sort: { fields: date, order: DESC }
      limit: 1
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...LatestPost
        }
      }
    }

    contentfulNavigationBar(node_locale: { eq: "en-US" }) {
      ...ContentfulNavQuery
    }

    wp {
      ...GeneralSettings
    }

    wpPost(id: { eq: $id }, locale: { locale: { eq: "en_US" } }) {
      ...node
    }

    allWpPost(
      sort: { fields: date, order: DESC }
      filter: { locale: { id: { eq: "en_US" } } }
    ) {
      edges {
        node {
          ...previewCardQuery
        }
      }
    }

    contentfulFooterV2(node_locale: { eq: "en-US" }) {
      ...ContentfulFooterQuery
    }
  }
`
